import { AnimatePresence, motion } from "framer-motion";
import { ArrowLeft, X } from "lucide-react";
import React from "react";

import { FitCheckResponse } from "../config/api";
import FitCheckReport from "./FitCheckReport";

interface FitCheckDetailDrawerProps {
	selectedFitCheck: FitCheckResponse | null;
	onClose: () => void;
}

export const FitCheckDetailDrawer = ({ selectedFitCheck, onClose }: FitCheckDetailDrawerProps) => (
	<AnimatePresence>
		{selectedFitCheck && (
			<>
				{/* Backdrop */}
				<motion.div
					className="fixed inset-0 bg-black bg-opacity-50"
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{ opacity: 0 }}
					onClick={onClose}
					style={{ zIndex: 50 }}
				/>
				{/* Drawer - slides in from left */}
				<motion.div
					className="fixed top-0 left-0 h-full w-full md:w-3/4 lg:w-2/3 xl:w-1/2 bg-white shadow-lg overflow-y-auto"
					initial={{ x: "-100%" }}
					animate={{ x: 0 }}
					exit={{ x: "-100%" }}
					transition={{ type: "spring", stiffness: 300, damping: 30 }}
					style={{ zIndex: 50 }}
				>
					<div className="p-4 md:p-6 h-full overflow-y-auto">
						{/* Close button */}
						<button className="absolute top-4 right-4 text-gray-500 hover:text-gray-700" onClick={onClose}>
							<X className="h-6 w-6" />
						</button>

						{/* Back button */}
						<button onClick={onClose} className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-6">
							<ArrowLeft className="w-4 h-4" />
							<span>Back to Dashboard</span>
						</button>

						{/* Job header */}
						<div className="bg-gray-50 rounded-xl border border-gray-200 p-6 mb-6">
							<h1 className="text-xl font-semibold text-gray-900 mb-1">{selectedFitCheck.fitCheck.roleTitle}</h1>
							<p className="text-gray-500">{selectedFitCheck.fitCheck.company}</p>
						</div>

						{/* FitCheck Report */}
						<div className="bg-white rounded-xl border border-gray-200 p-6">
							<FitCheckReport fitCheck={selectedFitCheck.fitCheck} />
						</div>
					</div>
				</motion.div>
			</>
		)}
	</AnimatePresence>
);

export default FitCheckDetailDrawer;
